import { combineReducers } from "redux";
//import { navReducers } from "./reducers/navReducers";
import { beachesReducers } from "./reducers/beachesReducers";
import { newsReducers } from "./reducers/newsReducers";
import { alertsReducers } from "./reducers/alertsReducers";
import { weatherReducers } from "./reducers/weatherReducers";

export default combineReducers({
  //nav: navReducers,
  beaches: beachesReducers,
  news: newsReducers,
  alerts : alertsReducers,
  weather: weatherReducers
});
